<template>
  <div style="display: grid; grid-template-columns: 400px 1fr">
    <div class="pa-4">
      <v-card elevation="0" class="card-box-shadow rounded-lg" max-width="390">
        <v-row no-gutters>
          <v-col cols="12" class="d-flex justify-center pb-2 pt-8">
            <v-img
              contain
              :src="
                companyDetails.company_details.logo
                  ? companyDetails.company_details.logo
                  : $globalConstant.profileImage
              "
              max-height="150"
              max-width="150"
              height="150"
              width="150"
              class="rounded-circle"
            />
          </v-col>
        </v-row>

        <v-card-title class="d-flex justify-center"
          >{{ companyDetails.first_name }}
          {{ companyDetails.last_name }}
        </v-card-title>

        <v-divider class="mx-4"></v-divider>

        <v-card-text class="pa-0">
          <v-row no-gutters class="py-5 px-8">
            <v-col cols="12" class="py-1">
              <OrderTooltipWithIcon
                v-if="companyDetails.company_details.name"
                icon="mdi-warehouse"
                :text="companyDetails.company_details.name"
                label="Company Name"
              />
            </v-col>
            <v-col cols="12" class="py-1">
              <OrderTooltipWithIcon
                icon="mdi-map-marker"
                v-if="companyDetails.company_details.address"
                :text="companyDetails.company_details.address"
                label="Address"
              />
            </v-col>
            <v-col cols="12" class="py-1">
              <OrderTooltipWithIcon
                v-if="companyDetails.email"
                icon="mdi-email"
                :text="companyDetails.email"
                label="Email"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </div>

    <div class="pa-4">
      <v-card
        elevation="0"
        class="card-box-shadow"
        style="height: calc(100vh - 100px)"
      >
        <v-card-title class="py-2">
          <span class="text-caption">Theme</span>
          <v-spacer></v-spacer>
          <v-btn
            class="ma-2"
            color="primary"
            depressed
            @click="showConfigForm = true"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-subtitle>
          <v-row>
            <v-col cols="12">
              Theme Name : {{ companyDetails.company_details.configuration.theme.name }}
            </v-col>
            <v-col cols="3" class="d-flex">
              <input
                type="color"
                id="primary"
                name="primary"
                class="mr-3"
                disabled
                :value="companyDetails.company_details.configuration.theme.primary"
              />
              <label for="primary">Primary</label>
            </v-col>
            <v-col cols="3" class="d-flex">
              <input
                type="color"
                id="primary"
                name="primary"
                class="mr-3"
                disabled
                :value="companyDetails.company_details.configuration.theme.secondary"
              />
              <label for="secondary">Secondary</label>
            </v-col>
            <v-col cols="3" class="d-flex">
              <input
                type="color"
                id="primary"
                name="primary"
                class="mr-3"
                disabled
                :value="companyDetails.company_details.configuration.theme.accent"
              />
              <label for="Navigation">Accent</label>
            </v-col>
            <v-col cols="3" class="d-flex">
              <input
                type="color"
                id="primary"
                name="primary"
                class="mr-3"
                disabled
                :value="companyDetails.company_details.configuration.theme.text_color"
              />
              <label for="Text">Text</label>
            </v-col>
          </v-row>
        </v-card-subtitle>
        <v-card-title class="pb-2 pt-6" v-if="companyDetails.company_details.website">
          <span class="text-caption">Website</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-subtitle v-if="companyDetails.company_details.website">
          <v-row>
            <v-col class="12" style="height:55vh">
              <iframe
                :src="companyDetails.company_details.website"
                style="width: 100%"
                height="100%"
              ></iframe>
            </v-col>
          </v-row>
        </v-card-subtitle>
      </v-card>
    </div>
    <CompanyConfigurationForm
      v-model="showConfigForm"
      @reloadWindow="reloadWindow"
    />
  </div>
</template>

<script>
import OrderTooltipWithIcon from "@/components/ModuleBasedComponents/Order/OrderTooltipWithIcon.vue";
import CompanyConfigurationForm from "@/components/ModuleBasedComponents/Company/CompanyConfigurationForm.vue";
import { bus } from "@/main";

export default {
  components: { OrderTooltipWithIcon, CompanyConfigurationForm },
  data() {
    return {
      companyDetails: {},
      showConfigForm: false,
      timeOut: null,
    };
  },
  methods: {
    reloadWindow() {
      bus.$emit("showLoader", true, "Reloading Window");
      setTimeout(() => {
        this.$api.profile
          .getUserProfile()
          .then((res) => {
            this.$permissions.setPermissions(res.data);
            bus.$emit("showLoader", false);
            window.location.reload();
          })
          .catch((err) => {
            console.error(err);
            bus.$emit("showLoader", false);
          });
      }, 3000);
    },
  },
  created() {
    let obj = this.$helper.getUserDetailsLocalStorage();
    this.companyDetails = {
      ...obj,
    };
  },
};
</script>

<style></style>
